import { stringField, optionField } from 'common/utils/form/fieldTypes';

export default {
  short_name: stringField({ required: true }),
  full_name: stringField({ required: true }),
  description: stringField({ required: true }),
  type: optionField({ required: true })
};
